import React, { useEffect, useState } from "react";
import MobilePage from "../../../Components/MobilePage";
import { useHistory, useRouteMatch } from "react-router";

import PackageInstanceProvider, {
  ACTIONS_SET_ADDED_TO_CART,
  ACTIONS_SET_ADDING_TO_CART,
  ACTIONS_SET_FAILED_ADDING_TO_CART,
  usePackageInstance,
} from "../../../../Providers/PackageInstanceProvider";
import EditPackage from "../../Components/EditTemplateProduct/EditPackage";
import AppBar from "../../Components/AppBar";
import { useShoppingCart } from "../../../providers/ShoppingCartProvider";
import { usePortal } from "../../../../Providers/PortalProvider";
import AddPackageToCartWarningDialog from "../../Components/AddPackageToCartWarningDialog";
import { toast } from "react-toastify";
import { usePriceList } from "@/react/Webshop/providers/PriceListProvider";
import useRetouch from "@/react/Webshop/hooks/useRetouch";
import ProductRetouch from "@/react/Webshop/Mobile/Pages/ProductRetouch/ProductRetouch";
import useViewItem from "@/react/Webshop/hooks/useViewItem";
import { viewedPackage } from "@/react/Webshop/utils/viewedItems";

const CreatePackageWrapper = () => {
  return (
    <PackageInstanceProvider>
      <CreatePackage />
    </PackageInstanceProvider>
  );
};

const CreatePackage = () => {
  const { params } = useRouteMatch();
  const {
    state,
    initializeInstanceByUuid,
    dispatch: packageDispatch,
  } = usePackageInstance();
  const { addItem } = useShoppingCart();
  const history = useHistory();
  const portal = usePortal();
  const [showAddToCartWarningDialog, setShowAddToCartWarningDialog] =
    useState(false);
  const { getRetouchPicturesByOrderLines } = useRetouch();
  const { hasRetouchProduct } = usePriceList();
  const [retouchPictures, setRetouchPictures] = useState(null);

  console.log("The portal", portal);

  useEffect(() => {
    initializeInstanceByUuid(params.packageUuid);
    return () => {
      //clearTemplateInstance();
    };
  }, []);

  useViewItem(!state.loading && state.uuid ? viewedPackage(state) : null);

  const handleAddToCart = () => {
    if (portal.webshop.package.addToCartWarning) {
      setShowAddToCartWarningDialog(true);
    } else {
      doAddToCart();
    }
  };

  const doAddToCart = () => {
    // Make sure the dialog is closed:
    setShowAddToCartWarningDialog(false);

    packageDispatch({
      type: ACTIONS_SET_ADDING_TO_CART,
      payload: {
        isAddingToCart: true,
      },
    });
    addItem({
      package: state,
    })
      .then((data) => {
        console.log("Create package", state);
        packageDispatch({
          type: ACTIONS_SET_ADDED_TO_CART,
        });
        if (data.error) {
          packageDispatch({
            type: ACTIONS_SET_ADDING_TO_CART,
            payload: {
              isAddingToCart: false,
            },
          });
          toast.error(data.error);
        } else {
          if (hasRetouchProduct && data.newOrderLines.length > 0) {
            const retouchPictures = getRetouchPicturesByOrderLines(
              data.newOrderLines,
            );
            if (retouchPictures.length > 0) {
              setRetouchPictures(retouchPictures);
              return;
            }
          }
          // Don't reset adding to cart complete state as redirect may take some time
          history.push("/shopping-cart");
        }
      })
      .catch((err) => {
        packageDispatch({
          type: ACTIONS_SET_FAILED_ADDING_TO_CART,
          payload: {
            error: err,
          },
        });
      });
    return;
  };

  if (state.loading) {
    return <div>Loading</div>;
  }

  if (retouchPictures !== null) {
    return <ProductRetouch pictures={retouchPictures} />;
  }

  return (
    <MobilePage>
      <AppBar />

      <EditPackage mode={"create"} handleUpdateCart={handleAddToCart} />
      {showAddToCartWarningDialog && (
        <AddPackageToCartWarningDialog
          handleCancel={() => setShowAddToCartWarningDialog(false)}
          handleAddToCart={doAddToCart}
        />
      )}
    </MobilePage>
  );
};

export default CreatePackageWrapper;
